import baseUrl from "../config/baseUrl";

const editClient = async ({
	token,
	name,
	description,
	contact_id,
	addClientType,
	addClientSubType,
	addClientStatus,
	client_reference_number,
	phone_number,
	email_id,
	source
}) => {
	// Values are URL-encoded so edited names/phones/reference numbers containing
	// characters such as &, #, + or spaces are saved exactly as typed.
	// (encodeURIComponent(undefined) is still "undefined", which the backend
	// already skips, so unchanged/absent fields behave as before.)
	const q = encodeURIComponent;
	let queryString = "";
	if (addClientSubType) {
		queryString = `&sub_type=${q(addClientSubType)}`;
	}
	try {
		const response = await fetch(
			`${baseUrl}/api/update-client-table-data?contact_id=${q(contact_id)}&name=${q(name)}&description=${q(description)}&type=${q(addClientType)}&status=${q(addClientStatus)}&client_reference_number=${q(client_reference_number)}&phone_number=${q(phone_number)}&email_id=${q(email_id)}${queryString}&source=${q(source)}`,
			{
				method: "PUT",
				headers: {
					Accept: "application/json",
					Authorization: `Bearer ${token}`,
				},
			}
		);
		const data = await response.json();
		return data;
	} catch (error) {
		return error;
	}
};

export default editClient;
